import axios from 'axios'
import { Message } from 'element-ui'
import {myLocalStorage} from '@/utils/storage'
import router from '../router'

let request = axios.create({
 // baseURL: urls[Math.floor(Math.random()*urls.length)],
  timeout: 10000,
  headers: {
    "Content-Type": "multipart/form-data",
    'Authorization':'Basic Y3RwYXJrOmN0cGFyaw=='
  }
 
})

request.interceptors.request.use(config => {
  let authority = null;
  try {
     authority=myLocalStorage.getItem('empInfo').session;
  } catch (error) {
    console.log(error);
  }
  // config.headers.Authorization = token;
  config.headers.authority = authority;
  return config;
}, error => {
  return Promise.reject(error);
})

request.interceptors.response.use(data => {
  if (data.data.code == 886) {
    // 886为session失效：
    myLocalStorage.removeItem('empInfo');
    router.push('/');
    Message({message: '登录状态过期，请重新登录', type: 'warning'});
  } else if (data.data.code == 200) {
    // 200为请求成功
  } else if(data.data.code == 404){
   //Message("没有找到相关数据，请换个条件试试",);
    console.log(data.data);
  } else{
    // 其他稀奇古怪的情况
    console.log(data.data);
    Message({message: data.data.msg,duration:'800'});
    return 
   }
  return data.data;
}, error => {
  return Promise.reject(error);
})

export default {
  get (url, data) {
    return request.get(url, data);
  },
  post (url, data) {
    return request.post(url, data);
  },
  put (url, data) {
    return request.put(url, data);
  },
  delete (url, data) {
    return request.delete(url, data);
  }
}


// WEBPACK FOOTER //
// ./src/http/uploadImg.js